import type {
  BffResponse,
  BffQueryParams,
} from '@volkswagen-onehub/car-technical-details-bff';
import {defaultParameterDefinition} from '@volkswagen-onehub/car-technical-details-bff/definitions';
import {BffRoutePath} from '@volkswagen-onehub/car-technical-details-bff';
import {createParameters} from '@volkswagen-onehub/vw-starter-framework';

export const createBffUrl = (
  baseUrl: string,
  options: BffQueryParams
): string => {
  const searchParams = new URLSearchParams();
  createParameters(searchParams, options, defaultParameterDefinition);
  const path: BffRoutePath<'default'> = '/bff/default';

  return `${baseUrl}${path}?${searchParams.toString()}`;
};

export async function loadBff(url: string): Promise<BffResponse> {
  const response = await fetch(url);

  if (response.status !== 200) {
    throw new Error('Failed to load bff data: ' + response.statusText);
  }
  return await response.json();
}
